import { IconNameEnum } from "@b2bportal/core-themes";
import type { SvgrComponent } from "@b2bportal/core-types";
import AirplaneArrive from "../../assets/client/airplane-arrive.svg?react";
import AirplanDepartChfar from "../../assets/client/airplane-depart-chfar.svg?react";
import AirplaneDepart from "../../assets/client/airplane-depart.svg?react";
import AirplaneFintech from "../../assets/client/airplane-fintech.svg?react";
import Airplane from "../../assets/client/airplane.svg?react";
import ArrowFork from "../../assets/client/arrow-fork.svg?react";
import Bell from "../../assets/client/bell.svg?react";
import BlackLock from "../../assets/client/black-lock.svg?react";
import BriefCase from "../../assets/client/briefcase-detail.svg?react";
import CalendarLoading from "../../assets/client/calendar-loading.svg?react";
import Calendar from "../../assets/client/calendar.svg?react";
import Cancel from "../../assets/client/cancel.svg?react";
import Moeny from "../../assets/client/card-fintech.svg?react";
import Card from "../../assets/client/card.svg?react";
import CheckmarkFilled from "../../assets/client/checkmark-filled.svg?react";
import CheckmarkSimple from "../../assets/client/checkmark-simple.svg?react";
import Checkmark from "../../assets/client/checkmark.svg?react";
import Chevron from "../../assets/client/chevron.svg?react";
import CircleCheck from "../../assets/client/circle-check.svg?react";
import ClockSolo from "../../assets/client/clock-solo.svg?react";
import Clock from "../../assets/client/clock.svg?react";

// Dark Mode Icons
import AirplaneArriveWhite from "../../assets/client/darkMode/airplane-arrive-white.svg?react";
import AirplanDepartChfarWhite from "../../assets/client/darkMode/airplane-depart-chfar-white.svg?react";
import AirplaneDepartWhite from "../../assets/client/darkMode/airplane-depart-white.svg?react";
import AirplaneWhite from "../../assets/client/darkMode/airplane-white.svg?react";
import ArrowForkWhite from "../../assets/client/darkMode/arrow-fork-white.svg?react";
import BellWhite from "../../assets/client/darkMode/bell-white.svg?react";
import CalendarWhite from "../../assets/client/darkMode/calendar-white.svg?react";
import CancelWhite from "../../assets/client/darkMode/cancel.svg?react";
import CardWhite from "../../assets/client/darkMode/card-white.svg?react";
import CheckmarkSimpleWhite from "../../assets/client/darkMode/checkmark-simple-white.svg?react";
import CheckmarkWhite from "../../assets/client/darkMode/checkmark-white.svg?react";
import FilterWhite from "../../assets/client/darkMode/filter-white.svg?react";
import InfoGrey from "../../assets/client/darkMode/info-grey.svg?react";
import LocationMarkerWhite from "../../assets/client/darkMode/location-marker-white.svg?react";
import LockLargeWhite from "../../assets/client/darkMode/lock-large-white.svg?react";
import LockWhite from "../../assets/client/darkMode/lock-white.svg?react";
import MissedConnectionWhite from "../../assets/client/darkMode/missed-connection-white.svg?react";
import OneWayWhite from "../../assets/client/darkMode/oneway-white.svg?react";
import PassengerWhite from "../../assets/client/darkMode/passenger-white.svg?react";
import PriceFreezeWhite from "../../assets/client/darkMode/price-freeze-white.svg?react";
import RefreshWhite from "../../assets/client/darkMode/refresh-white.svg?react";
import RoundTripWhite from "../../assets/client/darkMode/roundtrip-white.svg?react";
import ShieldDisruptionWhite from "../../assets/client/darkMode/shield-disruption-white.svg?react";
import ShieldWhite from "../../assets/client/darkMode/shield-white.svg?react";
import TicketWhite from "../../assets/client/darkMode/ticket-white.svg?react";
import WarningTriangleWhite from "../../assets/client/darkMode/warning-triangle.svg?react";
import WarningWhite from "../../assets/client/darkMode/warning-white.svg?react";

import DollarBill from "../../assets/client/dollar-bill.svg?react";
import ErrorIcon from "../../assets/client/error.svg?react";
import Filter from "../../assets/client/filter.svg?react";
import Headset from "../../assets/client/headset.svg?react";
import Info from "../../assets/client/info.svg?react";
import LocationMarker from "../../assets/client/location-marker.svg?react";
import Lock from "../../assets/client/lock.svg?react";
import MagnifyCheck from "../../assets/client/magnify-check.svg?react";
import MissedConnectionBlack from "../../assets/client/missed-connection-black.svg?react";
import MissedConnection from "../../assets/client/missed-connection.svg?react";
import OneWay from "../../assets/client/oneway.svg?react";
import Passenger from "../../assets/client/passenger.svg?react";
import PriceFreeze from "../../assets/client/price-freeze.svg?react";
import Refresh from "../../assets/client/refresh.svg?react";
import RoundTrip from "../../assets/client/roundtrip.svg?react";
import ShieldDisruption from "../../assets/client/shield-disruption.svg?react";
import Shield from "../../assets/client/shield.svg?react";
import Ticket from "../../assets/client/ticket.svg?react";
import Warning from "../../assets/client/warning-black.svg?react";
import WarningTriangle from "../../assets/client/warning-triangle.svg?react";
import WarningError from "../../assets/client/warning.svg?react";

import type { darkModeIcons, lightModeIcons } from "./sharedIcons";

type DarkModeR = {
  [K in keyof typeof darkModeIcons]: SvgrComponent;
};

export const darkModeIconsSvg: DarkModeR = {
  airplane: AirplaneWhite,
  airplaneArrive: AirplaneArriveWhite,
  airplaneDepart: AirplaneDepartWhite,
  airplaneFintech: AirplaneFintech,
  bell: BellWhite,
  calendar: CalendarWhite,
  card: CardWhite,
  clock: Clock,
  error: ErrorIcon,
  cancel: CancelWhite,
  checkmark: CheckmarkWhite,
  checkmarkFilled: CheckmarkFilled,
  checkmarkSimple: CheckmarkSimpleWhite,
  chevron: Chevron,
  circleCheck: CircleCheck,
  filter: FilterWhite,
  info: InfoGrey,
  locationMarker: LocationMarkerWhite,
  lock: LockLargeWhite,
  blackLock: LockWhite,
  oneway: OneWayWhite,
  roundtrip: RoundTripWhite,
  passenger: PassengerWhite,
  priceFreeze: PriceFreezeWhite,
  missedConnection: MissedConnection,
  shield: ShieldWhite,
  warning: WarningWhite,
  warningError: WarningError,
  warningTriangle: WarningTriangleWhite,
  shieldDisruption: ShieldDisruptionWhite,
  missedConnectionFintech: MissedConnectionWhite,
  airplaneDepartChfar: AirplanDepartChfarWhite,
  refresh: RefreshWhite,
  ticket: TicketWhite,
  arrowFork: ArrowForkWhite,
  magnifyCheck: MagnifyCheck,
  calendarLoading: CalendarLoading,
  clockSolo: ClockSolo,
  dollarBill: DollarBill,
  briefcase: BriefCase,
  [IconNameEnum.disruptionProtection]: AirplaneFintech,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineOne]: WarningWhite,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineTwo]: AirplaneWhite,
  [IconNameEnum.rightArrow]: ArrowFork,
  [IconNameEnum.disruptionConfirmationIcon]: CheckmarkWhite,
};

type LightModeR = {
  [K in keyof typeof lightModeIcons]: SvgrComponent;
};

export const lightModeIconsSvg: LightModeR = {
  airplane: Airplane,
  airplaneArrive: AirplaneArrive,
  airplaneDepart: AirplaneDepart,
  airplaneFintech: AirplaneFintech,
  bell: Bell,
  calendar: Calendar,
  cancel: Cancel,
  card: Card,
  clock: Clock,
  error: ErrorIcon,
  checkmark: Checkmark,
  checkmarkFilled: CheckmarkFilled,
  checkmarkSimple: CheckmarkSimple,
  chevron: Chevron,
  circleCheck: CircleCheck,
  filter: Filter,
  info: Info,
  locationMarker: LocationMarker,
  lock: Lock,
  blackLock: BlackLock,
  oneway: OneWay,
  roundtrip: RoundTrip,
  passenger: Passenger,
  priceFreeze: PriceFreeze,
  missedConnection: MissedConnection,
  shield: Shield,
  warning: Warning,
  warningError: WarningError,
  warningTriangle: WarningTriangle,
  shieldDisruption: ShieldDisruption,
  missedConnectionFintech: MissedConnectionBlack,
  airplaneDepartChfar: AirplanDepartChfar,
  refresh: Refresh,
  ticket: Ticket,
  arrowFork: ArrowFork,
  magnifyCheck: MagnifyCheck,
  calendarLoading: CalendarLoading,
  clockSolo: ClockSolo,
  dollarBill: DollarBill,
  briefcase: BriefCase,
  [IconNameEnum.disruptionProtection]: AirplaneFintech,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineOne]: Warning,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineTwo]: Airplane,
  [IconNameEnum.disruptionHowItWorksDialogBulletOne]: AirplaneDepart,
  [IconNameEnum.disruptionHowItWorksDialogBulletTwo]: Moeny,
  [IconNameEnum.disruptionHowItWorksDialogBulletThree]: Headset,
  [IconNameEnum.disruptionBulletPointOne]: AirplaneDepart,
  [IconNameEnum.disruptionBulletPointTwo]: Moeny,
  [IconNameEnum.disruptionBulletPointThree]: Headset,
  [IconNameEnum.rightArrow]: ArrowFork,
  [IconNameEnum.disruptionConfirmationIcon]: Checkmark,
};
